<template>
  <v-select
    class="small-text-field"
    :required="required"
    :value="rideType"
    :label="label"
    :items="rideTypesFiltered"
    :v-model="rideType"
    item-value="id"
    item-name="name"
    @input="updateSelf"
    :height="28"
    flat
    :hide-details="valid() == true && (error == null || error.length == 0)"
    :error-messages="valid() == true ? null : [valid()] "
    outlined
    dense
    style="width: 90px;"
  >
    <template v-slot:selection="{ item, index }">
      <span
        style="font-size: 12px !important"
        v-html="item.name.substring(0, 10).replace(' ', '&nbsp;')"
      ></span>
    </template>
    <template v-slot:item="{ item, index }">
      <span
        style="font-size: 12px !important"
        v-html="'<b>' + item.name.replace(' ', '&nbsp;') + '</b> &nbsp;' + 
       item.description.replace(' ', '&nbsp;')"
      ></span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "SelectableRideTypeForAvailabilityRegion",
  model: {
    prop: "rideType",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    rideType: Number,
    rideTypes: Array,
    error: String
  },
  computed: {
    rideTypesFiltered: function() {
      return this.rideTypes.filter(function(f) {
        return f.enabled == true;
      });
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    },
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
